import React from 'react';
import {findDOMNode} from 'react-dom';
import shallowCompare from '../../../lib/shallowCompare';
import ShoppingCartActions from '../../../actions/ShoppingCartActions';
import styles from './index.sass';

class ShippingMethodSelector extends React.Component {
  static propTypes = {
    shoppingCart: React.PropTypes.object,
    customer: React.PropTypes.object,
    invalid: React.PropTypes.bool
  };

  static contextTypes = {
    executeAction : React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnChangeShippingMethod(id, e) {
    this.setState({invalid: false});
    this.context.executeAction(ShoppingCartActions.setShippingMethod, {
      store_id: this.props.shoppingCart.store.id,
      shipping_method_id: id
    });
  }

  handleOnClickShippingMethod(id, e) {
    if(e.target === findDOMNode(this.refs[id])) {
      this.handleOnChangeShippingMethod(id);
    }
  }

  renderShippingMethods() {
    let { shoppingCart, customer } = this.props;
    let selectedShippingMethodId = shoppingCart.shipping_method_id;
    if(!shoppingCart.shipping_methods.size) {
      let zipCode = customer.preferences.zip_code;
      if(shoppingCart.shipping_address_id) {
        let shippingAddress = customer.shipping_addresses.find(sa => {
          return sa.id === shoppingCart.shipping_address_id;
        });
        if(shippingAddress) {
          zipCode = shippingAddress.zip_code;
        }
      }
      if(!zipCode) {
        return <p className={styles.noShippingMethodAvailable}>Please enter a shipping address to see shipping methods.</p>;
      }
      return <p className={styles.noShippingMethodAvailable}>{shoppingCart.store.name} is not shipping to {zipCode}</p>;
    }
    return shoppingCart.shipping_methods.map(shippingMethod => {
      let id = shippingMethod.id;
      let shippingMethodProps = {
        className : styles.shippingMethod,
        ref       : id,
        key       : id,
        onClick   : this.handleOnClickShippingMethod.bind(this, id)
      };
      let inputProps = {
        className : styles.checkbox,
        type      : 'checkbox',
        name      : id,
        id        : id,
        checked   : selectedShippingMethodId === id,
        onChange  : this.handleOnChangeShippingMethod.bind(this, id)
      };
      let labelProps = {
        className : styles.checkboxLabel,
        htmlFor   : id
      };
      return (
        <div {...shippingMethodProps}>
          <input {...inputProps} />
          <label {...labelProps}>
            <span className={styles.shippingMethodTitle}>{shippingMethod.title}</span>
            <span className={styles.shippingMethodPrice}>{shippingMethod.price_text}</span>
            <span className={styles.shippingMethodSubtitle}>{shippingMethod.subtitle}</span>
          </label>
        </div>
      );
    });
  }

  render() {
    return (
      <div className={styles.shippingMethodSelector + (this.props.invalid ? ` ${styles.invalid}` : '')}>
        <h3>Shipping method</h3>
        <div>
          {this.renderShippingMethods()}
        </div>
      </div>
    );
  }
}

export default ShippingMethodSelector;



// WEBPACK FOOTER //
// banquet/components/Checkout/ShippingMethodSelector/index.js